import { IconButton, Tooltip } from '@mui/material';
import { useOktaAuth } from '@okta/okta-react';
import { NavLink } from 'react-router-dom';
import logo from '../assets/squareLogo.jpg';
import headerBg from '../assets/background-header.jpg';

export function Header() {
  const { oktaAuth } = useOktaAuth();

  const logout = async () => {
    await oktaAuth.signOut();
  };

  return (
    <nav className="flex h-20 items-center justify-between px-10 py-3" style={{ backgroundImage: `url(${headerBg})` }}>
      <div className="flex h-16 items-center">
        <NavLink to="/" end>
          <img src={logo} alt="Company logo" className="h-14" />
        </NavLink>
        <div className="pl-3 text-2xl font-bold text-white">OCIO Reconciliation</div>
      </div>
      <Tooltip title="Sign Out">
        <IconButton
          size="large"
          aria-label="Logout"
          onClick={() => {
            void logout();
          }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" height="32" width="32" viewBox="0 0 640 640">
            <path
              fill="#ffffff"
              d="M224 160C241.7 160 256 145.7 256 128C256 110.3 241.7 96 224 96L160 96C107 96 64 139 64 192L64 448C64 501 107 544 160 544L224 544C241.7 544 256 529.7 256 512C256 494.3 241.7 480 224 480L160 480C142.3 480 128 465.7 128 448L128 192C128 174.3 142.3 160 160 160L224 160zM566.6 342.6C579.1 330.1 579.1 309.8 566.6 297.3L438.6 169.3C426.1 156.8 405.8 156.8 393.3 169.3C380.8 181.8 380.8 202.1 393.3 214.6L466.7 288L256 288C238.3 288 224 302.3 224 320C224 337.7 238.3 352 256 352L466.7 352L393.3 425.4C380.8 437.9 380.8 458.2 393.3 470.7C405.8 483.2 426.1 483.2 438.6 470.7L566.6 342.7z"
            />
          </svg>
        </IconButton>
      </Tooltip>
    </nav>
  );
}
